import { createContext } from "react";

import { type ContextPayload } from "../model/types/contextMenu";

export const Context = createContext<ContextPayload>({} as ContextPayload);
